<template>
    <title-card title="Elastic Search Cluster">
        <v-container fluid class="pa-1">
            <v-row>

                <v-col sm="12">
                    <div class="d-flex">

                        <v-icon color="white" x-large>mdi-heart-pulse</v-icon>

                        <v-sheet v-if="clusterState" rounded :color="clusterColor" class="ml-4 pt-1 pb-1 pl-2 pr-2 title">
                            {{ clusterState.toUpperCase() }}
                        </v-sheet>
                    </div>
                </v-col>

                <v-col sm="6">
                    <v-data-table
                        :items="items"
                        class="elevation-0"
                        hide-default-footer
                        hide-default-header
                    >
                        <template v-slot:body="{ items }">
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-right">{{ item.value.toLocaleString() }} MB</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-col>

                <v-col sm="6">
                    <v-data-table
                        :items="hardwareItems"
                        class="elevation-0"
                        hide-default-footer
                        hide-default-header
                    >
                        <template v-slot:body="{ items }">
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-right">{{ item.value }}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-col>

            </v-row>
        </v-container>

    </title-card>

</template>

<script>

import {mapState, mapGetters, mapActions} from 'vuex';
import Store from "../../TestGround/store";
import TitleCard from "../../../components/UI/TitleCard";

const vuexStore = 'TestGround';

export default {

    components: {TitleCard},

    props: ['name'],

    data() {
        return {
            data: [
                {}
            ]
        }
    },

    computed: {

        ...mapGetters(vuexStore, [
            'clusterStatsMemory',
            'clusterStatsHardware',
            'clusterState',
        ]),

        items() {
            return this.clusterStatsMemory;
        },

        hardwareItems() {
            return this.clusterStatsHardware;
        },

        clusterColor() {
            if (this.clusterState === 'green') return 'green darken-2';
            if (this.clusterState === 'yellow') return 'amber darken-2';
            if (this.clusterState === 'red') return 'red darken-2';
        }
    },

    methods: {

        ...mapActions(vuexStore, [
            'getClusterStats'
        ]),

        loadData(force = false) {

            this.getClusterStats(force)
                .then(() => {
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Cluster stats failed to load!'});
                });
        }
    },

    mounted() {
        this.loadData();
    },

    created() {
        if (!this.$store.state[vuexStore]) {
            this.$store.registerModule(vuexStore, Store);
        }
    },
}
</script>
